import { BaseQuery } from './BaseQuery';
import { IExecutionOptions } from '../models/query';
import { IQueryOptionsLoggedInUser } from '../models/query/options';
import { exec } from "child_process";

export class LoggedInUserQuery extends BaseQuery<IQueryOptionsLoggedInUser> {
	initialize(executionOptions: IExecutionOptions) {
	}
	getOptions(): IQueryOptionsLoggedInUser {
		const { key, code, options = {} } = this.queryOptions;
		return {
			key,
			code,
			...(options.loggedInUser || {}),
		};
	}
	getRawValue<T = any>(executionOptions: IExecutionOptions): T {
		const {
			key,
			code
		} = this.options;
		const loggedInUser =this.getLoggedInUser(executionOptions);
		if (loggedInUser) {
			if (code) {
				let result = loggedInUser[code];
				if (key && Array.isArray(result)) {
					result = result.map(element => element[key]);
				}
				return result;
			}
			return loggedInUser as any;
		}
		return;
	}
}